import React from 'react'
import { Link } from 'react-router-dom'
import projects from '../db.json'

function ProjectMiniCard({ project }) {
  const techKeys = project.techs?.[0] ? Object.entries(project.techs[0]).filter(([,v])=> v).map(([k])=>k).slice(0,4) : []
  return (
    <Link to={`/projects/${project.id}`} className="project-card">
      <div className="card-media">
        <img src={project.projectMainImg} alt={project.projectName} loading="lazy" />
        {/* <span className="card-badge">#{project.id} • Featured</span> */}
      </div>
      <div className="card-body">
        <div className="card-title">{project.projectName}</div>
        <div className="card-desc">{project.projectDescription || project.images?.[0]?.imgDescription || "Crafted with modern stack and great attention to UX."}</div>
        <div className="tech-row">
          {techKeys.map(k=> <span key={k} className="tech-pill">{k}</span>)}
        </div>
        <div className="card-footer">
          <span className="link-arrow">View case →</span>
          <span style={{fontSize:'0.72rem', color:'#94a3b8', fontWeight:600}}>{project.job ? 'Net Hawks' : 'Personal'}</span>
        </div>
      </div>
    </Link>
  )
}

export default function Home() {
  // last three: ids 12,11,10 - take highest ids
  const featured = [...projects].sort((a,b)=> b.id - a.id).slice(0,3)

  return (
    <div>
      {/* HERO */}
      <section className="hero">
        <div>
          <div className="badge"><span className="badge-dot"></span> Available for new projects</div>
          <h1>Full Stack & <span>GenAI Developer</span> building fast, useful products.</h1>
          <p className="hero-sub">
            I'm <strong>Bechir Dridi</strong> — 4+ years crafting scalable web & desktop apps with <strong>React, Vue, Node, Laravel</strong> and GenAI tools like <strong>LangChain & OpenAI</strong>. I turn ideas into high-performance, SEO-friendly apps used by real teams.
          </p>
          <div className="hero-actions">
            <Link to="/projects" className="btn btn-primary">Explore projects →</Link>
            <Link to="/contact" className="btn btn-ghost">Contact me</Link>
            <a href="mailto:b7dridi@gmail.com" className="btn btn-accent">Hire me</a>
          </div>
          <div className="hero-stats">
            <div className="stat"><strong>4+ yrs</strong><span>Experience</span></div>
            <div className="stat"><strong>Many</strong><span>Products shipped</span></div>
            <div className="stat"><strong>2</strong><span>Desktop apps</span></div>
            <div className="stat"><strong>GenAI</strong><span>LangChain • HF</span></div>
          </div>
        </div>

        <div className="hero-visual">
          <div className="hero-card">
            <div className="hero-card-head">
              <span className="dot dot-r"></span><span className="dot dot-y"></span><span className="dot dot-g"></span>
              <span>~/bechirdev — zsh</span>
            </div>
            <div className="code">
              <div><span className="cmt">{"// building with passion"}</span></div>
              <div><span className="kw">const</span> developer = {"{"}</div>
              <div>&nbsp;&nbsp;name: <span className="str">"Bechir Dridi"</span>,</div>
              <div>&nbsp;&nbsp;role: <span className="str">"Full Stack + GenAI"</span>,</div>
              <div>&nbsp;&nbsp;stack: [<span className="str">"React"</span>, <span className="str">"Next.js"</span>, <span className="str">"Vue"</span>, <span className="str">"Laravel"</span>],</div>
              <div>&nbsp;&nbsp;genAI: [<span className="str">"LangChain"</span>, <span className="str">"OpenAI"</span>],</div>
              <div>&nbsp;&nbsp;<span className="fn">ship</span>: () =&gt; <span className="str">"🚀 production"</span></div>
              <div>{"}"}</div>
            </div>
          </div>
          <div className="hero-float">
            <div className="float-icon">✓</div>
            <div className="float-text">
              <strong>Delivered with Net Hawks</strong>
              <span>MCQ Magician • Chart Master • USMLE Pulse</span>
            </div>
          </div>
        </div>
      </section>

      {/* FEATURED */}
      <section className="section">
        <div className="section-head">
          <div>
            <div className="eyebrow">Latest work</div>
            <h2>Featured projects — newest 3</h2>
          </div>
          <Link to="/projects" className="btn btn-ghost" style={{borderRadius:'999px'}}>View all projects →</Link>
        </div>
        <div className="projects-grid">
          {featured.map(p => <ProjectMiniCard key={p.id} project={p} />)}
        </div>
        <p style={{textAlign:'center', marginTop:'14px', color:'#64748b', fontSize:'0.88rem'}}>
          Showing <strong style={{color:'#0f172a'}}>IDs 12, 11, 10</strong> — the freshest work. See full archive with pagination on the projects page.
        </p>
      </section>

      {/* VALUE PROPS */}
      <section className="section" style={{paddingTop:0}}>
        <div className="skills-grid">
          <div className="skill-card">
            <h3>⚡ High performance</h3>
            <p>SSR with Next.js, optimized assets on Vercel/Supabase, snappy 90+ Lighthouse.</p>
          </div>
          <div className="skill-card">
            <h3>🤖 GenAI native</h3>
            <p>ChatGPT, voice, quiz generation and RAG with LangChain — real AI, not gimmicks.</p>
          </div>
          <div className="skill-card">
            <h3>🎨 Pixel to product</h3>
            <p>Figma → React/Tailwind → Electron/Tauri desktop. End-to-end delivery.</p>
          </div>
          <div className="skill-card">
            <h3>🔌 API obsessed</h3>
            <p>Firebase, Supabase, Prisma, REST. Clean contracts and reliable integrations.</p>
          </div>
        </div>
      </section>

      {/* SKILLS PREVIEW */}
      <section className="section" style={{paddingTop:0}}>
        <div className="eyebrow">Stack</div>
        <h2 style={{fontSize:'1.5rem', fontWeight:800, letterSpacing:'-0.02em', marginBottom:'12px'}}>A full-stack toolkit that ships.</h2>
        <div className="skills-grid">
          <div className="skill-card">
            <h3>Frontend</h3>
            <ul>
              <li className="mini-pill">React.js</li><li className="mini-pill">Next.js</li><li className="mini-pill">Vue.js</li><li className="mini-pill">Tailwind</li><li className="mini-pill">TypeScript</li>
            </ul>
          </div>
          <div className="skill-card">
            <h3>Backend</h3>
            <ul>
              <li className="mini-pill">Node / Express</li><li className="mini-pill">Laravel / PHP</li><li className="mini-pill">FastAPI / Python</li><li className="mini-pill">Prisma</li>
            </ul>
          </div>
          <div className="skill-card">
            <h3>Data & Cloud</h3>
            <ul>
              <li className="mini-pill">Supabase</li><li className="mini-pill">Firebase</li><li className="mini-pill">MySQL / PostgreSQL</li><li className="mini-pill">MongoDB</li>
            </ul>
          </div>
          <div className="skill-card">
            <h3>Desktop & Mobile</h3>
            <ul>
              <li className="mini-pill">Electron</li><li className="mini-pill">Tauri</li><li className="mini-pill">React Native</li><li className="mini-pill">Capacitor</li>
            </ul>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="section" style={{paddingTop:0}}>
        <div className="cta">
          <div>
            <h3>Have an idea? Let's build it fast.</h3>
            <p>From MVP to polished product — I help founders and teams ship in weeks, not months.</p>
          </div>
          <div style={{display:'flex', gap:'10px', flexWrap:'wrap'}}>
            <Link to="/contact" className="btn" style={{background:'white', color:'#0f172a'}}>Start a project</Link>
            <Link to="/about" className="btn" style={{border:'1px solid rgba(255,255,255,0.2)', color:'white'}}>About me</Link>
          </div>
        </div>
      </section>
    </div>
  )
}
